<!--
 * @FileDescription: 菜单管理（注释描述）
 * @Author: ryb（作者）
 * @Date: 2020-04-13（时间）
 * @LastEditors: ryb（最后更新人）
 * @LastEditTime: 2020-04-13（最后更新时间）
 -->
<template>
  <div class="add-menu-views">
    <div class="table-page-button">
      <a-button type="primary" class="border-arc" @click="btnAddMenu">新增</a-button>
    </div>
    <a-table :columns="columns" :dataSource="dataSource" bordered rowKey="id">
      <template slot="name" slot-scope="text, record">
        {{ record.name }}
      </template>
      <template slot="icon" slot-scope="text, record">
        {{ record.meta.icon }}
      </template>
      <template slot="operation" slot-scope="text, record">
        <a class="table-redact" @click="btnEditMenu(record)">编辑</a>
        <a-popconfirm title="确定删除吗?" @confirm="() => btnDeleteMenu(record.id)">
          <a>删除</a>
        </a-popconfirm>
      </template>
    </a-table>
    <new-add-menu ref="addmenu" @SuccessfullyAdded="SuccessfullyAdded"></new-add-menu>
  </div>
</template>
<script>
import newAddMenu from './modules/newAddMenu'
import { findPermissionAll, delPermission } from '@/utils/api'
export default {
  name: "addMenu",
  components: {
    newAddMenu
  },
  data () {
    return {
      columns: [
        {
          title: '菜单名称（按钮名称）',
          dataIndex: 'name',
          scopedSlots: { customRender: 'name' }
        }, {
          title: '菜单图标',
          dataIndex: 'icon',
          scopedSlots: { customRender: 'icon' }
        },
        {
          title: '菜单路径',
          dataIndex: 'url'
        },
        {
          title: '菜单组件',
          dataIndex: 'component'
        },
        {
          title: '按钮标识',
          dataIndex: 'buttonLabel'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
        }
      ],
      dataSource: []
    }
  },
  mounted () {
    this.findPermissionAll()
  },
  methods: {
    // 新增菜单（方法描述）
    btnAddMenu () {
      this.$refs.addmenu.show(1, this.dataSource)
    },
    // 修改菜单
    btnEditMenu (data) {
      this.$refs.addmenu.show(2, this.dataSource, data)
    },
    // 获取全部菜单
    findPermissionAll () {
      let _that = this
      var data = new FormData()
      data.append('companyStoreId',this.$store.state.shopId)
      data.append('permissionType','3')
      findPermissionAll(data,{},{}).then(res => {
        if (res.success) {
          this.dataSource = res.result
        }
      })
    },
    // 删除菜单按钮
    btnDeleteMenu (id) {
      let _that = this
      let formdata = new FormData()
      formdata.append('id', id)
      formdata.append("companyStoreId", this.$store.state.userInfo.companyStoreId)
      let header = {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
      delPermission(formdata, header,{
          companyStoreId:this.$store.state.shopId,
      }).then(res => {
        if (res.success) {
          this.findPermissionAll()
        }
      })
    },
    // 添加菜单成功
    SuccessfullyAdded () {
      this.findPermissionAll()
    }
  }
}
</script>
<style lang="scss">
.add-menu-views {
  height: calc(100vh - 300px);
  overflow: auto;
  .table-redact {
    margin-right: 10px;
  }
  .table-delete,
  .table-redact {
    cursor: pointer;
  }
}
</style>
